var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogosBitcoin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5399_155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1913 7.83839C11.3874 11.0635 8.11978 13.0241 4.89923 12.2201C1.67398 11.4162 -0.286557 8.14869 0.517429 4.92819C1.32137 1.70303 4.58423 -0.257503 7.80948 0.546482C11.03 1.34572 12.9953 4.61318 12.1913 7.83839Z",
    fill: "url(#paint0_linear_5399_155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21856 5.63279C9.33608 4.83365 8.72967 4.40117 7.89292 4.11442L8.16557 3.02852L7.50745 2.86399L7.2442 3.92168C7.07027 3.87938 6.89164 3.83707 6.713 3.79946L6.97625 2.73707L6.31813 2.57254L6.05018 3.65373C5.90446 3.62083 5.76343 3.58792 5.62711 3.55502V3.55032L4.71514 3.32468L4.54121 4.0298C4.54121 4.0298 5.0301 4.14262 5.0207 4.14732C5.28865 4.21314 5.33566 4.39177 5.32625 4.53279L5.016 5.76912C5.0348 5.77382 5.05831 5.77852 5.08651 5.79262C5.06301 5.78792 5.0395 5.78322 5.016 5.77382L4.58352 7.50373C4.55061 7.58364 4.466 7.70586 4.28267 7.65886C4.28737 7.66826 3.80318 7.54134 3.80318 7.54134L3.47412 8.29817L4.33438 8.51441C4.4942 8.55672 4.64933 8.59432 4.80446 8.63663L4.53181 9.73193L5.18993 9.89646L5.46258 8.81056C5.64121 8.85757 5.81984 8.90458 5.98907 8.94689L5.72113 10.0281L6.37924 10.1926L6.65189 9.09732C7.7801 9.30885 8.62625 9.22424 8.97881 8.20415C9.26556 7.38621 8.96471 6.91142 8.3724 6.60117C8.80958 6.50245 9.13394 6.2157 9.21856 5.63279ZM7.70958 7.74817C7.50745 8.56612 6.1254 8.12424 5.67882 8.01142L6.04078 6.55886C6.48736 6.67168 7.92582 6.89262 7.70958 7.74817ZM7.91642 5.61869C7.72839 6.36612 6.58138 5.98536 6.21001 5.89134L6.53907 4.5751C6.91044 4.66912 8.10916 4.84305 7.91642 5.61869Z",
    fill: "#EFE8DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5399_155",
    x1: 601.72,
    y1: 0.0773912,
    x2: 601.72,
    y2: 1203.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5399_155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.0342,
    height: 12.0342,
    fill: "white",
    transform: "translate(0.337158 0.366211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosBitcoin);
export default __webpack_public_path__ + "static/media/logos_bitcoin.21492f32efbcf872d3c3c3b179715a59.svg";
export { ForwardRef as ReactComponent };